import type { FilterModule } from "../index";
import { UploadedAccountsFilter } from "./UploadedAccountsFilter";
import {
  defaultUploadedAccountsSlice,
  type UploadedAccountsSlice,
} from "./slice";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { getChips, getCount } from "./chips";

export const uploadedAccountsModule: FilterModule<UploadedAccountsSlice> = {
  key: "uploadedAccounts",
  defaultSlice: defaultUploadedAccountsSlice,
  Component: UploadedAccountsFilter,
  toCompanyFilters,
  fromCompanyFilters,
  getChips,
  getCount,
};

export type { UploadedAccountsSlice, UploadState } from "./slice";
export { defaultUploadedAccountsSlice } from "./slice";
export type {
  UploadedAccountsOptions,
  UploadResponse,
  PollResponse,
} from "./options";
export { useUploadedAccountsSync } from "./useUploadedAccountsSync";
